import { entity } from "simpler-state";

export const initializationState = entity({
  isInitialized: false,
  stage: "preInit",
  error: null,
});

// socket connection status
export const isOnline = entity(false);

// current userId associated with client
export const connectedAsUser = entity(null);

// total unread count, updates as events come through
export const totalUnreadCount = entity(0);

// total unread channel count, updates as events come through
export const totalUnreadChannelCount = entity(0);

/*
channel entities: (see flattenRawChannel)
  channelId: 'string'
  name: 'string'
  image: 'string'
  description: 'string'
  type: 'room' or 'dm'
  isMember: boolean,
  isMuted: boolean,
  isTyping: boolean,
  memberUserIds: ['otherUserId', ...],
  hostUserIds: ['hostUserId', ...],
  unreadCount: integer,
  lastReadAt: Date,
  lastMessage: Message,
  memberLeaderId: 'string',
  publisherId: 'string',
*/
// root store for channels { [channelId]: <channel> }
export const channelsByChannelId = entity({});

/*
message entities: (see flattenRawMessage)
  messageId: 'string'
  markdown: 'string'
  userId: 'string'
  createdAt: Date,
  reactions: [{ id: string, count: integer, byMe: boolean, latestNames: [<string>] }, ...]
*/
// root store for messages { [channelId]: [<message>, ...] }
export const messagesByChannelId = entity({});

/*
user entities: (see flattenRawUser)
  userId: 'string'
  name: 'string'
  firstName: 'string'
  company: 'string'
  avatar: 'string'
  title: 'string'
  location: 'string'
  role: 'string'
  isOnline: boolean
*/
// root store for users { [userId]: <user> }
export const usersById = entity({});

// store for typing users by channel { [channelId]: [<user>, ...] }
export const usersTypingByChannelId = entity({});

/*
raw channel info obj: (see registerRawChannel)
  rawChannel: sdk channel interface
  bound: boolean // true if rawChannel.on(handleChannelEvent)
  watch: boolean // if { watch: true } was used on query or .watch was called
  state: boolean // if { state: true } was used on watch or query
  presence: boolean // if { presence: true } was used on watch or query
*/
// { [channelId]: <raw channel info> }
export const rawChannelsById = new Map();
